import { CreateTableOutput, DeleteItemOutput } from 'aws-sdk/clients/dynamodb';
import { AWSError } from 'aws-sdk/lib/error';
import { PromiseResult } from 'aws-sdk/lib/request';
import uuid from 'uuid';

import {
  DEFAULT_DYNAMO_DB_CLIENT,
  DynamoDBClient,
  DynamoDBTableClient,
} from '../../shared/aws/dynamodb';

import { CONNECTION_TABLE_SCHEMA } from './schema';

type MonitorConnection = {
  connectionId: string;
  monitorId: string;
};

export interface ConnectionDatasource {
  createConnection(monitorId: string): Promise<string>;
  deleteConnection(
    monitorId: string,
    connectionId: string
  ): Promise<PromiseResult<DeleteItemOutput, AWSError>>;
  findConnectionsForMonitor(monitorId: string): Promise<MonitorConnection[]>;
}

export class DynamoConnectionDatasource implements ConnectionDatasource {
  private readonly dynamoClient: DynamoDBTableClient;

  public constructor(dynamoClient: DynamoDBClient = DEFAULT_DYNAMO_DB_CLIENT) {
    this.dynamoClient = new DynamoDBTableClient(CONNECTION_TABLE_SCHEMA.TableName, dynamoClient);
  }

  public createTable = (): Promise<PromiseResult<CreateTableOutput, AWSError>> => {
    return this.dynamoClient.createTable(CONNECTION_TABLE_SCHEMA);
  };

  public createConnection = (monitorId: string): Promise<string> => {
    const connectionId = uuid.v4();
    const Item: MonitorConnection = {
      connectionId,
      monitorId,
    };

    return this.dynamoClient.putDocumentToDynamo({ Item }).then(_ => connectionId);
  };

  public deleteConnection = (monitorId: string, connectionId: string) => {
    const Key: MonitorConnection = {
      monitorId,
      connectionId,
    };

    return this.dynamoClient.deleteItem({ Key });
  };

  public findConnectionsForMonitor = (monitorId: string) => {
    return this.dynamoClient
      .queryTable({
        KeyConditionExpression: `monitorId = :monitorId`,
        ExpressionAttributeValues: {
          ':monitorId': monitorId,
        },
      })
      .then(resp => resp.Items as MonitorConnection[]);
  };
}

const dynamoConnectionDatasource = new DynamoConnectionDatasource();

export default dynamoConnectionDatasource;
